import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import {
  Card,
  CardMedia,
  CardContent,
  Typography,
  Box,
  Chip,
  Button,
  Grid,
} from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import HomeIcon from '@mui/icons-material/Home';
import VisibilityIcon from '@mui/icons-material/Visibility';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import SendIcon from '@mui/icons-material/Send';
import { KeyUri, config } from "../key";

const vendorToken = localStorage.getItem("vendorToken")
  ? localStorage.getItem("vendorToken")
  : null;
 // console.log("vendor token in my properties", vendorToken)
export function MyProperties({ onPropertySelect, onPropertyEdit }) {
  const navigate = useNavigate();
  const [properties, setProperties] = useState([]);
  const [loading, setLoading] = useState(true);
  const [hotelPricing, setHotelPricing] = useState(null);

useEffect(() => {
  async function fetchPricing() {
    try {
      const token = localStorage.getItem('token')?.replace(/^"|"$/g, '').trim();
      const res = await axios.get(`${KeyUri.BACKEND_URI}/hotelpricing`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setHotelPricing(res.data.data);  
    } catch (err) {
      console.error('Failed to fetch hotel pricing', err);
      setHotelPricing(null);
    }
  }
  fetchPricing();
}, []);


  useEffect(() => {
    async function fetchProperties() {
      try {
        //const vendorToken = localStorage.getItem("vendorToken");
        const response = await axios.get(KeyUri.BACKEND_URI + '/get-properties', {
          headers: { Authorization: `Bearer ${vendorToken}` },
        });
        setProperties(response.data.data || []);
      } catch (error) {
        console.error('Error fetching properties:', error);
        setProperties([]);
      } finally {
        setLoading(false);
      }
    }
    fetchProperties();
  }, []);

   const handleViewProperty = (property) => {
   
    if (onPropertySelect) {
        onPropertySelect({
      ...property,
      _fullData: true, 
      accommodations: property.accommodations || []
    });
    } else {
      navigate(`/property/${property._id}`);  
    }
  };

  const handleEditProperty = (propertyId) => {

  if (onPropertyEdit) {
    onPropertyEdit(propertyId);  
  } else {
    navigate(`/property/edit/${propertyId}`);
  }
};

    const getTotalPrice = (basePrice = 0, pricing = {}) => {
    const gst = pricing.gst_price || 0;                   
    const platformFee = pricing.platform_price || 0;      
    const misc = pricing.miscellaneous_charges || 0;      
    const add1 = pricing.additional_charges_one || 0;      
    const add2 = pricing.additional_charges_two || 0;     
    
    const totalFees = gst + platformFee + misc + add1 + add2;
    const totalPrice = basePrice + totalFees;
    
    return { totalPrice, totalFees, gst, platformFee };
  };
  
  const handleDelete = async (propertyId) => {
    if (!window.confirm('Are you sure you want to delete this property?')) return;

    try {
      await axios.delete(`${KeyUri.BACKEND_URI}/delete-property/${propertyId}`, {
        headers: { Authorization: `Bearer ${vendorToken}` },
      });

      
      setProperties((prev) => prev.filter((prop) => prop._id !== propertyId));
      alert('Property deleted successfully!');
    } catch (error) {
      console.error('Failed to delete property:', error);
      alert('Failed to delete property.');
    }
  };

  const handleSubmit = async (propertyId) => {
  if (!window.confirm('Submit this property for approval? You may not be able to edit it while it is under review.')) return;

  try {
    const res = await axios.patch(
      `${KeyUri.BACKEND_URI}/submit-property/${propertyId}`,
      {},
      { headers: { Authorization: `Bearer ${vendorToken}` } }
    );

    // update the card in place so the chip flips to "Pending"
    setProperties((prev) =>
      prev.map((p) => (p._id === propertyId ? { ...p, status: res.data.data?.status || 'pending' } : p))
    );
    alert('Property submitted for approval!');
  } catch (error) {
    console.error('Failed to submit property:', error);
    alert(error.response?.data?.message || 'Failed to submit property.');
  }
};

 const getStatusChip = (status, changeRequestStatus) => (
  <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
    {status === 'approved' && <Chip size="small" label="Approved" color="success" />}
    {status === 'pending' && <Chip size="small" label="Pending" color="warning" />}
    {status === 'draft' && <Chip size="small" label="Draft" variant="outlined" />}
    {status === 'rejected' && <Chip size="small" label="Rejected" color="error" />}
    {status === 'approved' && changeRequestStatus === 'pending' && (
      <Chip size="small" label="Changes Pending" color="warning" variant="outlined" />
    )}
    {status === 'approved' && changeRequestStatus === 'rejected' && (
      <Chip size="small" label="Changes Rejected" color="error" variant="outlined" />
    )}
  </Box>
);

// Mirrors the server's submit validation so vendors see what's missing BEFORE clicking Submit
  const getMissingFields = (p) => {
    const missing = [];
    if (!p.propertyName?.trim()) missing.push('property name');
    if (!p.propertyType) missing.push('property type');
    if (!p.description?.trim()) missing.push('description');
    if (!p.location?.address) missing.push('address');
    if (!p.location?.city) missing.push('city');
    if (!p.location?.state) missing.push('state');
    if (!p.location?.pincode) missing.push('pincode');
    if (!p.contact?.person) missing.push('contact person');
    if (!p.contact?.email) missing.push('contact email');
    if (!p.contact?.phone) missing.push('contact phone');
    if (!(p.totalAccommodations || p.accommodations?.length)) missing.push('at least one accommodation');
    return missing;
  };

  if (loading) {
    return <Typography>Loading properties...</Typography>;
  }

  if (properties.length === 0) {
    return <Typography>No properties found.</Typography>;
  }

  return (
    <Box sx={{ mt: 3 }}>
      <Box sx={{ mb: 2, display: 'flex', flexDirection: 'column', gap: 1 }}>
        <Typography variant="h4" fontWeight={700}>My Properties</Typography>
        <Typography color="text.secondary">Manage all your listed properties</Typography>
      </Box>

      <Grid container spacing={3}>
        {properties.map((property) => (
          <Grid item xs={12} lg={6} key={property._id}>
            <Card
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          overflow: 'hidden',
          height: '100%',
        }}
      >
               <CardMedia
          component="img"
          sx={{
            width: { xs: '100%', sm: 192 },   
            height: { xs: 180, sm: '100%' },   
            objectFit: 'cover',
          }}
          image={property.images?.[0]?.url || 'placeholder.jpg'}
          alt={property.propertyName}
        />
              <CardContent sx={{ flex: 1, minWidth: 0, p: { xs: 2, md: 3 } }}>
                  <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', sm: 'row' },
              justifyContent: 'space-between',
              gap: 1,
              mb: 2,
            }}
          >
                  <Box sx={{ width: '100%', minWidth: 0 }}>
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        flexWrap: 'wrap',
                        gap: 1,
                      }}
                    >
                      <Typography variant="h6" sx={{ wordBreak: 'break-word' }}>
                        {property.propertyName}
                      </Typography>
  {getStatusChip(property.status, property.changeRequestStatus)}
</Box>
                    <Typography variant="body2" color="text.secondary">{property.propertyType}</Typography>
                    {(property.status === 'draft' || property.status === 'rejected') &&
                      getMissingFields(property).length > 0 && (
                        <Typography variant="caption" color="warning.main" sx={{ display: 'block', mt: 0.5 }}>
                          Incomplete — still needed: {getMissingFields(property).join(', ')}
                        </Typography>
                      )}
                  </Box>
                 
                </Box>

                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, mb: 2 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, color: 'text.secondary' }}>
                    <LocationOnIcon fontSize="small" />
                    <Typography variant="body2">
                      {property.location?.city}, {property.location?.state}
                    </Typography>
                  </Box>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, color: 'text.secondary' }}>
                    <HomeIcon fontSize="small" />
                    <Typography variant="body2">
  {property.totalAccommodations || property.accommodations?.length || 0} Accommodations
</Typography>

                  </Box>
                </Box>

                 <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', sm: 'row' },
              flexWrap: 'wrap',
              gap: 1,
            }}
          >
                  <Button 
    variant="outlined" 
    size="small" 
    startIcon={<VisibilityIcon />} 
    onClick={() => handleViewProperty(property)} 
  >
    View
  </Button>
  {(property.status === 'draft' || property.status === 'rejected') && (
                    getMissingFields(property).length > 0 ? (
                      <Button variant="outlined" color="warning" size="small" startIcon={<EditIcon />}
                        onClick={() => handleEditProperty(property._id)}>
                        Complete Details
                      </Button>
                    ) : (
                      <Button variant="contained" size="small" startIcon={<SendIcon />}
                        onClick={() => handleSubmit(property._id)}>
                        {property.status === 'rejected' ? 'Resubmit' : 'Submit'}
                      </Button>
                    )
                  )}
                  <Button variant="outlined" size="small" startIcon={<EditIcon />}  onClick={() => handleEditProperty(property._id)}>Edit</Button>
                  <Button variant="outlined" size="small" color="error" startIcon={<DeleteIcon />} onClick={() => handleDelete(property._id)}>Delete</Button>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}